enum statusEnum {
	OK = 'OK',
	badRequest = 400
}

export default statusEnum
